import intlTelInput from "intl-tel-input";

// Reformat the displayed phone number and
// update the hidden input value that will be submitted by the form.
const assemblePhoneNumber = (lv, dispatch = true) => {
  const input = lv.querySelector("input[type=tel]");
  const iti = window.intlTelInputGlobals.getInstance(input);
  const hiddenInput = lv.parentElement.querySelector("input[type=hidden]");

  // Format the displayed number
  iti.setNumber(input.value);

  // Update hidden form input
  if (input.value !== "" && iti.getNumber() !== "") {
    // Only use the iti number if the input value is set and the iti formatted number is set.
    // We do not want to clear the hidden value if the input value is set, but for whatever reason
    // the iti formatted number is empty string.
    hiddenInput.value = iti.getNumber();
  } else {
    hiddenInput.value = input.value;
  }

  if (dispatch) {
    // Trigger phx-change event on the form so that this input's new value is
    // preserved in socket assigns
    hiddenInput.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

export default {
  TelephoneInput: {
    mounted() {
      let inputTimer;
      const input = this.el.querySelector("input[type=tel]");
      const iti = intlTelInput(input, {
        loadUtils: import("intl-tel-input/build/js/utils"),
        initialCountry: "us",
        preferredCountries: ["us", "ca"],
        separateDialCode: true,
      });

      // When the user updates the input value or when the country is changed,
      // trigger an update to the hidden input value.
      input.addEventListener("input", () => {
        // Debounced call to avoid excessive round trips
        clearTimeout(inputTimer);
        inputTimer = setTimeout(() => {
          assemblePhoneNumber(this.el);
        }, 800);
      });

      input.addEventListener("countrychange", () => {
        assemblePhoneNumber(this.el);
      });
    },
    updated() {
      // Received updated value from LiveView (data attribute updated).
      let newValue;

      if (this.el.dataset.value) {
        // Obtain new value from data attribute of the updated element.
        newValue = this.el.dataset.value;
      } else {
        // The new value is likely undefined/not set. So use empty string to clear the input.
        newValue = "";
      }

      // Update the input's value and validate/format phone number.
      const input = this.el.querySelector("input[type=tel]");
      input.value = newValue;

      // Assemble phone number, but do not dispatch phx-change event to LiveView. This is
      // unnecessary because LiveView is already aware of the new value and by triggering
      // the phx-change event could cause the user's input to disappear while typing.
      assemblePhoneNumber(this.el, false);

      // If the field has an error, add the error class.
      if (this.el.dataset.hasError == "true") {
        input.classList.add("is-danger");
      } else {
        input.classList.remove("is-danger");
      }
    },
  },
};
